import { render, staticRenderFns } from "./StatsBalance.vue?vue&type=template&id=60c1ff47&"
import script from "./StatsBalance.vue?vue&type=script&lang=js&"
export * from "./StatsBalance.vue?vue&type=script&lang=js&"
import style0 from "./StatsBalance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports